module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.3d3a53586bd78d1069ae.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module chunks = 17